export const theme = {
  peopleLabelColor: Styles.color.grey.one,
  cartPreviewItemPColor: Styles.color.grey.one,
};
